<template>
  <div class="modal-container">
    <vxe-form ref="xForm" class="my-form2" title-align="right" title-width="150" :data="formData">
      <vxe-form-item title="企业名称：" field="mobile" span="24">
        <template>
          <vxe-input v-model="formData.companyName" placeholder="请输入企业名称"></vxe-input>
        </template>
      </vxe-form-item>
      <vxe-form-item title="用户名：" field="userName" span="24">
        <template>
          <vxe-input v-model="formData.userName" placeholder="请输入用户名"></vxe-input>
        </template>
      </vxe-form-item>
      <vxe-form-item title="交换密码：" field="password" span="24">
        <template>
          <vxe-input type="password" v-model="formData.password" placeholder="请输入交换密码"></vxe-input>
        </template>
      </vxe-form-item>
      <vxe-form-item title="公钥：" field="publicKey" span="24">
        <template>
          <vxe-input v-model="formData.publicKey" placeholder="请输入公钥"></vxe-input>
        </template>
      </vxe-form-item>
      <vxe-form-item title="AppID：" field="appId" span="24">
        <template>
          <vxe-input v-model="formData.appId" placeholder="请输入AppID"></vxe-input>
        </template>
      </vxe-form-item>
      <vxe-form-item title="AppSecret：" field="appSecret" span="24">
        <template>
          <vxe-input v-model="formData.appSecret" placeholder="请输入AppSecret"></vxe-input>
        </template>
      </vxe-form-item>
      <vxe-form-item title="上传接口url：" field="hostExchange" span="24">
        <template>
          <vxe-input v-model="formData.hostExchange" placeholder="请输入上传接口url"></vxe-input>
        </template>
      </vxe-form-item>
    </vxe-form>
    <div class="modal-footer add-btn-box">
      <Button @click="cancel" style="width: 100px;">取 消</Button>
      <Button status="primary" @click="updateConfig" style="width: 100px;">确 定</Button>
    </div>
  </div>
</template>

<script>
  import $api from "@/apiProvider";
  import $C from "@/consts/index";
  import {showLoading, hideLoading, isEmpty} from "@/utils/util";

  export default {
    name: "ReportCompDetail",
    data() {
      return {
        formData: {}
      };
    },
    methods: {
      showEdit(row) {
        this.formData = row;
      },
      async updateConfig() {
        let res = await $api.reportData.post("updateConfig", this.formData);
        if (res.status === 1) {
          this.$Message.success("修改成功");
          this.cancel();
          this.$emit('afterSave');
        } else {
          this.$XModal.alert({
            message: res.message ? res.message : "接口异常",
            status: "error",
          });
        }
      },
      cancel() {
        this.$emit('close');
      },
      close() {
        this.formData = {};
      }
    },
  };
</script>

<style scoped>
  .modal-container {
    position: relative;
    height: 100%;
  }

  .modal-footer {
    box-sizing: border-box;
    padding: 10px 0;
    border-top: 1px solid #eee;
    display: flex;
    justify-content: flex-end;
    width: 98%;
    position: absolute;
    bottom: 0;
  }

  .grey {
    color: #808695;
  }
</style>